import { Link } from 'react-router-dom';
import { cfmt, pfmt } from '../../lib/api';
import { TID } from '../../constants/testIds';

export default function NeighbourhoodCard({ n, sub = null }) {
    return (
        <Link
            to={`/neighbourhoods/${n.slug}`}
            data-testid={TID.home.featuredCard}
            className="group block border border-neutral-200 bg-white hover:border-brand-navy transition-colors"
           
        >
            <div className="aspect-[4/3] bg-neutral-100 overflow-hidden">
                <img
                    src={n.hero_image}
                    alt={n.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
                />
            </div>
            <div className="p-5">
                <div className="flex items-center justify-between">
                    <div className="overline">{n.city} · {n.province}</div>
                    <div className={`font-mono-data text-[12px] tabular ${n.price_1yr_change_pct >= 0 ? 'text-[#0B8A3E]' : 'text-[#C3341C]'}`}>
                        {n.price_1yr_change_pct >= 0 ? '+' : ''}{pfmt(n.price_1yr_change_pct)} 1Y
                    </div>
                </div>
                <div className="font-editorial text-[22px] leading-tight mt-2 tracking-editorial">{n.name}</div>
                <div className="text-[13.5px] text-neutral-600 mt-2 line-clamp-2">{n.tagline}</div>
                <div className="flex items-center justify-between mt-5 pt-4 border-t border-neutral-100">
                    <div>
                        <div className="overline">Median</div>
                        <div className="font-mono-data text-[14px] tabular mt-1">{cfmt(n.median_price)}</div>
                    </div>
                    <div className="text-right">
                        <div className="overline">Walk</div>
                        <div className="font-mono-data text-[14px] tabular mt-1">{n.metrics?.walkability ?? '-'}</div>
                    </div>
                    <div className="text-right">
                        <div className="overline">Schools</div>
                        <div className="font-mono-data text-[14px] tabular mt-1">{n.metrics?.schools ?? '-'}</div>
                    </div>
                    <div className="text-right">
                        <div className="overline">5Y f&apos;cast</div>
                        <div className="font-mono-data text-[14px] tabular mt-1 text-[#2F6B47]">+{pfmt(n.forecast_5yr_pct)}</div>
                    </div>
                </div>
                {sub && <div className="mt-3 text-[12px] text-neutral-500">{sub}</div>}
            </div>
        </Link>
    );
}
